import { BatteryFull, Signal, Wifi } from 'lucide-react';

/**
 * The marketing phone (DESIGN.md › Phone Frame): device-black bezel, dynamic island, 9:41 bar, white screen.
 * The app inside is drawn at its own 390px width and zoomed down to the frame (styles/pages/landing.css).
 */
export const PhoneFrame = ({ className = '', children }) => (
  <div className={`lp-phone ${className}`.trim()}>
    <div className="lp-phone__screen">
      <div className="lp-phone__island" aria-hidden="true" />
      <div className="lp-phone__status" aria-hidden="true">
        <span>9:41</span>
        <span className="lp-phone__signal">
          <Signal />
          <Wifi />
          <BatteryFull />
        </span>
      </div>
      <div className="lp-phone__app">{children}</div>
    </div>
  </div>
);
